import { useQuery } from '@hooks/reactQuery';

import { auth } from '@store/selectors';
import { useAppSelector } from '@store/store';

import { getUserProfile } from '@api/userProfile';

import { IUserProfile } from '@interfaces/user/userProfile';

import { refetchOptions } from '@constants/common';
import { USER_PROFILE } from '@constants/queryKeys';

export const useQueryUserProfile = () => {
	const { activeOrganisation } = useAppSelector(auth);

	const {
		data: userProfile,
		isLoading: isLoadingUserProfile,
		isFetching: isFetchingUserProfile,
	} = useQuery<IUserProfile>({
		queryKey: [USER_PROFILE],
		queryFn: getUserProfile,
		enabled: [!!activeOrganisation],
		...refetchOptions,
	});

	return {
		userProfile,
		isLoadingUserProfile: isLoadingUserProfile || isFetchingUserProfile,
	};
};
